import { Inject, Injectable } from "@angular/core";
import { SwPush } from "@angular/service-worker";
import { ApiService } from "app/core/api/api.service";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PushNotificationService {


    readonly VAPID_PUBLIC_KEY = environment.VAPID_PUBLIC;

    constructor(
        private swPush: SwPush,
        private api: ApiService,
    ){

    }

    subscribeToNotifications() {
        
        this.swPush.requestSubscription({
            serverPublicKey: this.VAPID_PUBLIC_KEY
        })
        .then(sub => this.api.addPushSubscriber(sub).subscribe())
        .catch(err => console.error("Could not subscribe to notifications", err));
    }

}